// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import None from '../_raw/service/icon_none.svg';
import withIconProps from '../withIconProps';

export default withIconProps(None);
